export default __webpack_public_path__ + "static/headerLogo-a28410a6ac1b7e177bec9fbe21ae2047.svg";